export function isSupported() {
  return typeof globalThis.requestIdleCallback === "function" && typeof globalThis.Blob === "function" && typeof globalThis.URL === "function" && typeof globalThis.Worker === "function";
}
